/* eslint-disable react/no-array-index-key */

import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { PortalQualificationSellingPoint } from './PortalQualificationSellingPoint';
import './PortalQualificationSellingPoints.scss';

export const PortalQualificationSellingPoints = function (props) {
  const { anchor, title, blurb, sellingPoints } = props;

  return (
    <portal-qualification-selling-points id={anchor}>
      <div className="row portal-section selling-points">
        <div className="columns small-11 small-centered medium-10 medium-centered">
          <h2>{title}</h2>
          <h4 className="portal-section-blurb">{blurb}</h4>
          {sellingPoints && (
            <div className="qualification-selling-points clearfix">
              {sellingPoints.map((sellingPoint, i) => (
                <PortalQualificationSellingPoint
                  key={i}
                  {...{ sellingPoint }}
                  firstChild={i === 0}
                  lastChild={i === sellingPoints.size - 1}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </portal-qualification-selling-points>
  );
};

PortalQualificationSellingPoints.displayName =
  'PortalQualificationSellingPoints';
PortalQualificationSellingPoints.propTypes = {
  anchor: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  blurb: PropTypes.string.isRequired,
  sellingPoints: ImmutablePropTypes.listOf(
    ImmutablePropTypes.mapContains({
      imageSrc: PropTypes.string,
      text: PropTypes.string,
    })
  ).isRequired,
};
